import EmergencyFund from "./EmergencyFund"
import Education from "./Education"
import Retirement from "./Retirement"
import HomePurchase from "./HomePurchase"
import College from "./College"
import LifeInsurance from "./LifeInsurance"
import DebtPayoff from "./DebtPayoff"
import PrivateSchool from "./PrivateSchool"
import Other from "./Other"
import Car from "./Car"
import Charity from "./Charity"
import Caregiving from "./Caregiving"
import StudentLoanPayoff from "./StudentLoanPayoff"
import WorkPause from "./WorkPause"

const CardTypes = {
  EmergencyFund,
  Education,
  HomePurchase,
  Retirement,
  College,
  LifeInsurance,
  DebtPayoff,
  PrivateSchool,
  Other,
  Car,
  Charity,
  Caregiving,
  StudentLoanPayoff,
  WorkPause
}

export default CardTypes
